import styled from 'styled-components';

import { Text } from '@/nova/components';
import { COLORS, MOBILE } from '@/nova/theme/tokens';
import { softCard } from '@/nova/theme/mixins';

// A read-only Lumio row: same recessed card surface as the affiliate cards, but no
// hover wash and no pointer cursor (the row does not drill into a detail view).
export const Row = styled.div`
  ${softCard}
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  ${MOBILE} {
    flex-wrap: wrap;
  }
`;

export const Thumb = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Name = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const Meta = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  ${MOBILE} {
    width: 100%;
    justify-content: space-between;
  }
`;
